var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-tooltip textOverflow"},[(_vm.$getStrleng(_vm.text) > 4)?_c('a-tooltip',{attrs:{"title":_vm.text,"overlay-class-name":"td-tooltip"}},[_vm._v("\n    "+_vm._s(_vm.$substr(_vm.text, 4))+"\n  ")]):_c('span',[_vm._v(_vm._s(_vm.text || '- -'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }